import { css } from 'aphrodite/no-important';
import { RedButton } from 'components/RedButton/RedButton';
import { style } from 'components/VideoTile/style';
import { VideoData } from 'models';
import React, { FC } from 'react';
import { PlayIcon } from 'util/icons';

interface Props {
  videoObject: VideoData;
  onBioClick: (bioUrls: string[]) => void;
  onVideoClick: (video: VideoData) => void;
  disabled?: boolean;
  voiceOverBadge?: string;
  maxColumnCount?: number;
  copy: {
    speaker_bio_button_text: string;
    speaker_bios_button_text: string;
  };
}

export const VideoTile: FC<Props> = ({
  videoObject,
  disabled = false,
  onVideoClick,
  onBioClick,
  voiceOverBadge,
  copy,
  maxColumnCount = 3,
}) => {
  const styles = style({ maxColumnCount, showVoiceOverBadge: !!voiceOverBadge });
  const {
    video_title,
    thumbnail_url,
    mobile_thumbnail_url,
    speaker_names,
    speaker_titles,
    speaker_bio_urls,
  } = videoObject;

  const isVideoPlayable = !disabled && !!videoObject.video_url;

  const handleVideoClick = () => {
    if (!isVideoPlayable) {
      return;
    }

    onVideoClick({ ...videoObject });
  };

  return (
    <div className={css(styles.videoContainer)}>
      <div className={css(styles.thumbnailContainer)} onClick={handleVideoClick}>
        <picture>
          <source media='(min-width: 768px)' srcSet={thumbnail_url} />
          <img src={mobile_thumbnail_url} alt={video_title} className={css(!isVideoPlayable && styles.videoDisabled)} />
        </picture>
      </div>

      <RedButton
        className={css(styles.bioButton, styles.bioButtonTablet)}
        onClick={(e) => {
          if (e) e.stopPropagation();
          onBioClick(speaker_bio_urls);
        }}>
        {speaker_bio_urls.length > 1 ? copy.speaker_bios_button_text : copy.speaker_bio_button_text}
      </RedButton>

      {isVideoPlayable && (
        <div className={css(styles.playVideo)}>
          <button className={css(styles.playVideoButton)} onClick={handleVideoClick}>
            <PlayIcon /> Play Video
          </button>
        </div>
      )}
      <div className={css(styles.videoHeadline)}>
        {voiceOverBadge && <span className={css(styles.voiceOverBadge)}>{voiceOverBadge}</span>}
        <h4 dangerouslySetInnerHTML={{ __html: video_title }} />
      </div>

      <p
        className={css(styles.speaker, styles.speakerName)}
        dangerouslySetInnerHTML={{ __html: speaker_names.join(' / ') }}
      />
      <p
        className={css(styles.speaker, styles.speakerTitle)}
        dangerouslySetInnerHTML={{ __html: speaker_titles.join(' / ') }}
      />
      <RedButton
        className={css(styles.bioButton, styles.bioButtonMobile)}
        onClick={(e) => {
          if (e) e.stopPropagation();
          onBioClick(speaker_bio_urls);
        }}>
        {speaker_bio_urls.length > 1 ? copy.speaker_bios_button_text : copy.speaker_bio_button_text}
      </RedButton>
    </div>
  );
};
